module.exports = __webpack_public_path__ + "img/excellent-support.3b281715.jpg";